import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { errorToast } from '@app/utils/notifications'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect/lib'
import ChatPage from '../components/ChatPage'

export default connect(
  createStructuredSelector<
    ApplicationState,
    ICurrentUserState
  >({
    user: selectCurrentUser(),
  }),
  {
    errorToast,
  }
)(ChatPage)
